<template>
  <div class="content" v-loading="loading">
    <div class="content-wrapper" v-if="!limit">
      <div style="position: relative;">
        <OrderInfoCard :orderInfo="orderData.orderInfo || {}" :priceDetails="orderData.priceInfos"></OrderInfoCard>
        <slot name="orderCustom" :orderInfo="orderData.orderInfo"></slot>
      </div>
      <InfoCard title="行程信息">
        <IntFeePanel :journeySegments="orderData.journeySegments" :payTotalInfo="null" :isFixed="false" :productInfo="orderData.ruleInfo" />
      </InfoCard>
      <PassengerInfoCard :passengers="orderData.passengers" />
      <ConcatInfoCard :contact="orderData.contact" />
    </div>
    <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; color: #666; background: #fff;" v-else>
      <img src="https://static.a6air.com/wxapp/icon_request_limit.png" style="width: 364px; height: 261px" />
      <span style="line-height: 112px">操作过于频繁，请稍后再试</span>
    </div>
  </div>
</template>

<script>
import InfoCard from "@/views/components/infoCard.vue";
import IntFeePanel from "@/views/components/intFeePanel.vue";
import { queryIntOrderDetail } from "@/api/newsapi";
import OrderInfoCard from "./OrderInfoCard.vue";
import PassengerInfoCard from "./PassengerInfoCard.vue";
import ConcatInfoCard from "./ConcatInfoCard.vue";
export default {
  name: "IntOrderDetail",
  components: { InfoCard, IntFeePanel, OrderInfoCard, PassengerInfoCard, ConcatInfoCard },
  data() {
    return {
      orderNo: "",
      limit: false,
      orderData: {},
      loading: false,
      intervalTime: "",
      orderCanPay: false
    };
  },

  mounted() {
    this.orderNo = this.$route.params.orderNo;
    this.queryOrderDetail(this.orderNo);
  },
  methods: {
    async queryOrderDetail(serialNo) {
      this.limit = false;
      try {
        this.loading = true;
        const res = await queryIntOrderDetail({ serialNo });
        if (res.success) {
          this.orderData = res.data;
          this.payInterval();
        } else {
          if (res.errorCode === "A60511009101") {
            this.limit = true;
          }
          this.orderData = {};
          this.$message.error(res.errorMessage);
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    toPay() {
      window.open( "/route/casherpay?bank=alipay&orderNo=" + this.orderNo, "_blank" );
    },
    payInterval() {
      const timeInterval = setInterval(() => {
        const payTimeLimit = this.orderData.orderInfo?.payTimeLimit || 0;
        const remainMs = payTimeLimit - new Date().getTime();
        if (remainMs <= 0) {
          clearInterval(timeInterval);
          this.intervalTime = "";
          this.orderCanPay = true;
          return;
        }
        this.intervalTime = this.formatDuring(remainMs);
      }, 1000);
    },
    formatDuring(mss) {
      var minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = (mss % (1000 * 60)) / 1000;
      seconds = parseInt(seconds);
      return minutes + " 分 " + seconds + " 秒 ";
    },
  }
};
</script>

<style lang="less" scoped>
.next-step {
  width: 100%;
  height: 53px;
  border: 0;
  background-color: #d70039;
  color: #fff;
  font-size: 16px;
  margin: 42px 0 53px;
  cursor: pointer;
}
.next-step:active {
  background-color: #b11e45;
}
.step-disabled {
  background-color: #ccc;
}
.step-disabled.next-step:active {
  background-color: #ccc;
}
</style>
